import React from 'react'
import { InventoryTable, PanelTitle } from './InventoryShared';

const reportColumns = [
    { key: 'name', label: 'Item' },
    { key: 'category', label: 'Category' },
    { key: 'value', label: 'Value' },
    { key: 'status', label: 'Status', badge: true },
];

function getReportRows(type, data) {
    const items = data.items || [];

    if (type === 'stock-summary') {
        return items.map(item => ({ ...item, value: `${item.currentStock} ${item.unit}` }));
    }

    if (type === 'stock-valuation') {
        return items.map(item => ({ ...item, value: item.lastPurchase.amount }));
    }

    if (type === 'raw-material-report') {
        return items.filter(item => item.category === 'Raw').map(item => ({ ...item, value: `${item.currentStock} ${item.unit}` }));
    }

    if (type === 'consumption') {
        return items.map(item => ({ ...item, value: `${item.usedToday} ${item.unit}` }));
    }

    if (type === 'opening-closing') {
        return items.map(item => ({ ...item, value: `${item.openingStock} → ${item.currentStock} ${item.unit}` }));
    }

    if (type === 'purchase') {
        return items.map(item => ({ ...item, value: item.lastPurchase.amount }));
    }

    if (type === 'wastage-report') {
        return items.map(item => ({ ...item, value: `${item.wastage} ${item.unit}` }));
    }

    if (type === 'supplier') {
        return data.suppliers.map(item => ({
            id: item.id,
            name: item.name,
            category: item.contact,
            value: item.pending,
            status: item.lastOrder,
        }));
    }

    return items.map(item => ({ ...item, value: `${item.currentStock} ${item.unit}` }));
}

function InventoryReportPage({ title, type, data }) {
    return (
        <section className='inventory-panel inventory-table-panel full'>
            <PanelTitle title={title} />
            <InventoryTable columns={reportColumns} rows={getReportRows(type, data)} />
            <div className='inventory-actions sticky'>
                <button>Export PDF</button>
                <button>Export Excel</button>
            </div>
        </section>
    );
}

export default InventoryReportPage
